import React from 'react';
import { ListingBadges } from '@domain-group/fe-allhomes-library';
import { variables } from '@domain-group/fe-brary';
import * as styles from './allhomes-listing-card-badges.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var colour = variables.colour;
var getBadge = badge => {
  var bgColour;
  if (badge.name === ListingBadges.underApplication.name) {
    bgColour = colour.brandYellow;
  } else if (badge === ListingBadges.featuredProperty) {
    bgColour = colour.brandAqua;
  }
  return ___EmotionJSX("span", {
    key: badge.label,
    css: styles.badge(badge, bgColour)
  }, badge.label);
};
var reduceBadges = (list, annotation) => {
  var badge = ListingBadges[annotation.badge];
  if (!badge) {
    return list;
  }
  var existingBadge = list[badge.priority];
  if (existingBadge && existingBadge.groupedPriority < badge.groupedPriority) {
    return list;
  }
  badge.label = annotation.label;
  list[badge.priority] = badge;
  return list;
};
export var AllhomesListingCardBadges = _ref => {
  var _ref$annotations = _ref.annotations,
    annotations = _ref$annotations === void 0 ? [] : _ref$annotations;
  var underOffer = annotations.filter(badge => badge.badge === ListingBadges.underOffer.name);
  return ___EmotionJSX("div", {
    css: styles.wrapper
  }, underOffer.length > 0 ? ___EmotionJSX("span", {
    css: styles.badge(ListingBadges.underOffer, ListingBadges.underOffer.colour)
  }, underOffer[0].label) : annotations.reduce(reduceBadges, []).map(badge => getBadge(badge)));
};